import { ISponsorship, Sponsorship } from './../../../../models/Sponsorship.model';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ParrainageService } from '../../../../services/parrainage.service';
import { AuthService } from '../../../../services/auth.service';
import { UserService } from '../../../../services/user.service';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { DatePipe } from '@angular/common';
import * as XLSX from "xlsx";

@Component({
  selector: 'app-parrainage',
  templateUrl: './parrainage.component.html',
  styleUrls: ['./parrainage.component.scss']
})
export class ParrainageComponent implements OnInit {

  @ViewChild('closebutton') closebutton;
  @ViewChild('closebutton1') closebutton1;
  sponsorships = [];
  sponsorshipsTmp = [];
  page: number = 1;
  count: number = 0;
  tableSize: number = 10;
  tableSizes: any = [10, 15, 30, 50];
  search: any;
  perPage = 20;

  sorted1 = false;
  sorted2 = false;
  sorted3 = false;
  sorted4 = false;
  sorted5 = false;
  sorted6 = false;
  sorted7 = false;
  sorted8 = false;

  constructor(private parrainageService : ParrainageService,
              private fb: FormBuilder, private authService: AuthService,private userService: UserService,
              private router: Router,private datePipe: DatePipe) { }

  ngOnInit(): void {
    this.getAllSponsorships();
  }

  disableEndDate = true;
  displayError = false;
  beginDate: any = null;
  endDate: any = null;
  //Récupération de la date de début
  getBeginDate(event:any){
    this.beginDate=event.target.value;
    //console.log(this.beginDate)
    if(this.beginDate){
      this.disableEndDate = false;
      if(this.beginDate > this.endDate){
        this.displayError = true;
      }else{
        this.displayError = false;
      }
    }else{
      this.disableEndDate = true;
    }
  }

  // Récupération de la date de fin
  getEndDate(event){
    this.endDate=event.target.value;
  }

  filterParrainage() {
    if (this.endDate == null || this.beginDate== null) {
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Veuillez choisir une date de début et une date de fin s\'il vous plaît',
        showConfirmButton: false,
        timer: 3500
      })
      return;
    }
    if (this.endDate!= null && this.beginDate!= null && this.beginDate <= this.endDate) {
      const dateString = this.endDate;
      const date = new Date(dateString);
      date.setDate(date.getDate() + 1);
      this.endDate = this.datePipe.transform(date,'yyyy-MM-dd');
      this.sponsorships = this.sponsorshipsTmp;
      this.sponsorships = this.sponsorships.filter((sp) => {
        let dateRef = this.datePipe.transform(sp.date, 'yyyy-MM-dd');
        return (this.beginDate == null || dateRef >= this.beginDate) && (this.endDate == null || dateRef <= this.endDate);
      });
    }
  }

  selectTransactionStatus(value: any) {
    const selectSponsorShip: ISponsorship[] = [];
    this.sponsorships = this.sponsorshipsTmp;
    if (value !== 'all') {
      if(value=="validée"){
        this.sponsorships.forEach(value1 => {
          if (value1?.status) {
            selectSponsorShip.push(value1);
          }
        });
      }
      if(value=="enattente"){
        this.sponsorships.forEach(value1 => {
          if (value1?.status==null || value1.status == false) {
            selectSponsorShip.push(value1);
          }
        });
      }
      this.sponsorships = selectSponsorShip;
    }else{
      this.sponsorships = this.sponsorshipsTmp;
    }
  }

  searchFilter($event: KeyboardEvent) {
    this.search = this.search.toString().toLowerCase();
    this.sponsorships = this.sponsorshipsTmp;
    this.sponsorships = this.sponsorships.filter(value =>
      value.firstname?.toUpperCase().includes(this.search) || value.firstname?.toLowerCase().includes(this.search)
      || value?.lastname?.toUpperCase().includes(this.search) || value?.lastname?.toLowerCase().includes(this.search)
      || value?.username?.toUpperCase().includes(this.search) || value?.username?.toLowerCase().includes(this.search)
      || value?.residenceCountry?.toUpperCase().includes(this.search) || value?.residenceCountry?.toLowerCase().includes(this.search)
      || value?.residenceCity?.toUpperCase().includes(this.search) || value?.residenceCity?.toLowerCase().includes(this.search)
      || value?.email?.toUpperCase().includes(this.search) || value?.email?.toLowerCase().includes(this.search)
      || value?.gender?.toUpperCase().includes(this.search) || value?.gender?.toLowerCase().includes(this.search)
      || value?.phoneNumber.includes(this.search)
    );
  }


  resetFilter() {
    this.getAllSponsorships();
    this.beginDate = null;
    this.endDate = null;
  }

  getAllSponsorships(){
    this.parrainageService.listeParrains().subscribe(rs=>{
      this.sponsorships = rs;
      this.sponsorshipsTmp = rs;
     // console.log("Liste des parrainages");
     // console.log(rs);
    });
  }

  selectDisplayedSponshor(value: any){
    this.perPage = parseInt(value, 10);
  }

  sponsorShipForm = this.fb.group({

  });

  get f2() { return this.sponsorShipForm.controls; }

  onSubmit(){

  }

  currentSponsorShip: any = null;
  onViewSponsorShip(sponshor: any) {
    this.parrainageService.getidParrainsById(sponshor.id).subscribe(parrain =>  {
      //console.log("Détails du parrain.....");
     // console.log(parrain);
      this.currentSponsorShip = parrain;
    });
  }


  deleteSponsorship(sponsorship: Sponsorship){
    Swal.fire({
      title: 'Voulez-vous vraiment supprimer cet demande de parrainage ?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonText: 'Non',
      confirmButtonText: 'Oui'
    }).then((result) => {
      if (result.isConfirmed) {
        this.parrainageService.deleteSponsorship(sponsorship.id).subscribe(
          rs=> {
            this.getAllSponsorships();
            Swal.fire({
              position: 'top-end',
              icon: 'success',
              title: 'Article supprimé avec succès.',
              showConfirmButton: false,
              timer: 1500
            });
          }, error => {
            // console.log(error);
            Swal.fire({
              position: 'top-end',
              icon: 'error',
              title: 'Erreur de suppression',
              showConfirmButton: false,
              timer: 1500
            })
          }
        )
      }
    })
  }

  exportexcel(fileName): void {
    /* table id is passed over here */
    let element = document.getElementById('excel-table');
    const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, fileName);

  }

  sort1() {
    if(this.sorted1 == false) {
      // @ts-ignore
      this.sponsorships.sort((a, b) => a.username > b.username ? 1 : a.username < b.username ? -1 : 0)
      this.sorted1 = true;
    } else {
      // @ts-ignore
      this.sponsorships.sort((a, b) => a.username < b.username ? 1 : a.username > b.username ? -1 : 0)
      this.sorted1 = false;
    }
  }

  sort2() {
    if(this.sorted2 == false) {
      // @ts-ignore
      this.sponsorships.sort((a, b) => a.lastname.toLowercase  > b.lastname.toLowercase ? 1 : a.lastname < b.lastname ? -1 : 0)
      this.sorted2 = true;
    } else {
      // @ts-ignore
      this.sponsorships.sort((a, b) => a.lastname.toLowercase  < b.lastname.toLowercase  ? 1 : a.lastname > b.lastname ? -1 : 0)
      this.sorted2 = false;
    }
  }

  sort3() {
    if(this.sorted3 == false) {
      // @ts-ignore
      this.sponsorships.sort((a, b) => a.firstname > b.firstname ? 1 : a.firstname < b.firstname ? -1 : 0)
      this.sorted3 = true;
    } else {
      // @ts-ignore
      this.sponsorships.sort((a, b) => a.firstname < b.firstname ? 1 : a.firstname > b.firstname ? -1 : 0)
      this.sorted3 = false;
    }
  }

  sort4() {
    if(this.sorted4 == false) {
      // @ts-ignore
      this.sponsorships.sort((a, b) => a.residenceCountry > b.residenceCountry ? 1 : a.residenceCountry < b.residenceCountry ? -1 : 0)
      this.sorted4 = true;
    } else {
      // @ts-ignore
      this.sponsorships.sort((a, b) => a.residenceCountry < b.residenceCountry ? 1 : a.residenceCountry > b.residenceCountry ? -1 : 0)
      this.sorted4 = false;
    }
  }

  sort5() {
    if(this.sorted5 == false) {
      // @ts-ignore
      this.sponsorships.sort((a, b) => a.residenceCity > b.residenceCity ? 1 : a.residenceCity < b.residenceCity ? -1 : 0)
      this.sorted5 = true;
    } else {
      // @ts-ignore
      this.sponsorships.sort((a, b) => a.residenceCity < b.residenceCity ? 1 : a.residenceCity > b.residenceCity ? -1 : 0)
      this.sorted5 = false;
    }
  }

  sort6() {
    if(this.sorted6 == false) {
      // @ts-ignore
      this.sponsorships.sort((a, b) => a.email > b.email ? 1 : a.email < b.email ? -1 : 0)
      this.sorted6 = true;
    } else {
      // @ts-ignore
      this.sponsorships.sort((a, b) => a.email < b.email ? 1 : a.email > b.email ? -1 : 0)
      this.sorted6 = false;
    }
  }

  sort7() {
    if(this.sorted7 == false) {
      // @ts-ignore
      this.sponsorships.sort((a, b) => a.gender > b.gender ? 1 : a.gender < b.gender ? -1 : 0)
      this.sorted7 = true;
    } else {
      // @ts-ignore
      this.sponsorships.sort((a, b) => a.gender < b.gender ? 1 : a.gender > b.gender ? -1 : 0)
      this.sorted7 = false;
    }
  }

  sort8() {
    if(this.sorted8 == false) {
      // @ts-ignore
      this.sponsorships.sort((a, b) => a.phone > b.phone ? 1 : a.phone < b.phone ? -1 : 0)
      this.sorted8 = true;
    } else {
      // @ts-ignore
      this.sponsorships.sort((a, b) => a.phone < b.phone ? 1 : a.phone > b.phone ? -1 : 0)
      this.sorted8 = false;
    }
  }

}
